import { OutletListItem } from '@ancon/wildcat-types'
import { createEntityAdapter } from '@reduxjs/toolkit'

export const outletListEntityAdapter = createEntityAdapter<OutletListItem>()
